// extracted by mini-css-extract-plugin
export var orderDetails = "_su-2";
export var orderImage = "_su-1";
export var orderMeta = "_su-3";
export var orderSummary = "_su-0";
export var rightArrow = "_su-4";